<template>
    <div :class="['wrapper', classes]">
        <header class="main-header" style="display:none;">
            <!-- Header Navbar -->
            <nav
                class="navbar navbar-static-top navbar2"
                role="navigation">
                <!-- Sidebar toggle button-->
                
                <a href="/">
                    <img
                        src="/static/img/back_home_img.png"
                        alt="Logo"
                        class="img-responsive center-block logo "
                        style="width: 300px; height: 42px; margin-top: 20px; background-color: #3c8dbc;" />
                </a>


                <div class="text-center col-md-10 col-md-offset-2" style="margin-top: -60px;">
                    <div class="row">
                        <div class="text-left col-md-8 col-md-offset-2">
                            <ul class="indexSteps">
                                <li class="indexStepLi">{{$i18n.messages[$i18n.locale].indexProduct}}</li>
                                <li class="indexStepLi">{{$i18n.messages[$i18n.locale].indexNews}}</li>
                                <li class="indexStepLi">
                                    <div class="dropdown">
                                        <a data-toggle="dropdown" href="#">{{$i18n.messages[$i18n.locale].indexResource}}</a>
                                        <ul class="resourceSteps dropdown-menu w100" role="menu" aria-labelledby="dLabel">
                                            <li class="resourceStepLi">
                                                {{$i18n.messages[$i18n.locale].indexDoc}}
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="indexStepLi">
                                    <a v-bind:href="forumUrl" target="_new">
                                        {{$i18n.messages[$i18n.locale].indexForum}}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="text-right col-md-2 navbar-custom-menu" style="margin-top: 10px;">
                            <ul class="nav navbar-nav" style="float: right;">
                                <li class="dropdown messages-menu">
                                    <a
                                        href="javascript:;"
                                        class="dropdown-toggle"
                                        data-toggle="dropdown">
                                        <i class="fa fa-language fa-lg"></i>
                                    </a>
                                    <ul class="dropdown-menu" style="width: 100px; min-width: 80px">
                                        <li>
                                            <!-- inner menu: contains the messages -->
                                            <ul class="menu">
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        @click="$_admin_dash_change_lang('zh-TW')"
                                                    >
                                                        <div class="row">
                                                            <div class="col-xs-2 text-right">
                                                                <i
                                                                v-if="$root.$i18n.locale === 'zh-TW'"
                                                                class="fa fa-check label-success"></i>
                                                            </div>
                                                            <div class="col-xs-6 text-center">
                                                                <h4 style="margin: 0 0 0 0; color: black">
                                                                    tw
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        @click="$_admin_dash_change_lang('en')"
                                                    >
                                                        <div class="row">
                                                            <div class="col-xs-2 text-right">
                                                                <i
                                                                v-if="$root.$i18n.locale === 'en'"
                                                                class="fa fa-check label-success"></i>
                                                            </div>
                                                            <div class="col-xs-6 text-center">
                                                                <h4 style="margin: 0 0 0 0; color: black">
                                                                    en
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <!-- end message -->
                                            </ul>
                                            <!-- /.menu -->
                                        </li>
                                    </ul>
                                </li>

                                <li
                                v-show="!email"
                                class="dropdown notifications-menu">
                                    <a
                                        href="javascript:;"
                                        class="dropdown-toggle"
                                        @click="$_admin_index_login()"
                                        >
                                        {{$i18n.messages[$i18n.locale].indexLogin}}
                                    </a>
                                </li>
                                <li
                                v-show="!email"
                                class="dropdown notifications-menu">
                                    <a
                                        href="javascript:;"
                                        class="dropdown-toggle"
                                        @click="$_admin_index_register()"
                                        >
                                        {{$i18n.messages[$i18n.locale].indexRegister}}
                                    </a>
                                </li>

                                <li 
                                v-show="email"
                                class="dropdown notifications-menu">
                                    <a
                                        href="javascript:;"
                                        class="dropdown-toggle"
                                        data-toggle="dropdown">
                                        <i class="fa fa-user"></i>
                                    </a>
                                    <ul class="dropdown-menu" style="min-width: 180px; width: 180px;">
                                        <li>
                                            <!-- Inner Menu: contains the notifications -->
                                            <ul class="menu">
                                                <li>
                                                    <!-- start notification -->
                                                    <router-link :to="{name: 'listApp'}">
                                                        <div class="row">
                                                            <div class="col-xs-4 text-right">
                                                                <i class="fa fa-cog text-aqua"></i>
                                                            </div>
                                                            <div class="col-xs-6 text-center">
                                                                {{ $t('indexControlPanel') }}
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </li>
                                                <li>
                                                    <!-- start notification -->
                                                    <router-link v-if="isAdmin" :to="{name: 'logout'}">
                                                        <div class="row">
                                                            <div class="col-xs-4 text-right">
                                                                <i class="fa fa-sign-out text-yellow"></i>
                                                            </div>
                                                            <div class="col-xs-6 text-center">
                                                                {{ $t('logout') }}
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                    <router-link v-if="!isAdmin" :to="{name: 'userLogout'}">
                                                        <div class="row">
                                                            <div class="col-xs-4 text-right">
                                                                <i class="fa fa-sign-out text-yellow"></i>
                                                            </div>
                                                            <div class="col-xs-6 text-center">
                                                                {{ $t('logout') }}
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </li>
                                                <!-- end notification -->
                                            </ul>
                                        </li>
                                        
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </nav>
        </header>

        <sidebar/>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper" style="min-height: 900px; ">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    
                </h1>
            </section>

            <router-view></router-view>
        </div>
        <!-- /.content-wrapper -->

        <!-- Main Footer -->
        <footer class="main-footer" style="display:none;">
            <strong>Copyright &copy; {{year}}
                <a href="https://www.nuwarobotics.com/">NUWA Robotics</a>.</strong> All rights reserved.
        </footer>
        <BackTop/>
    </div>
    
    <!-- ./wrapper -->
</template>

<script>
    import faker from 'faker'
    import { mapState } from 'vuex'
    import config from '../config'
    import Sidebar from './Sidebar'
    import 'hideseek'
    import BackTop from './views/BackTop.vue'
    export default {
        name: 'Dash',
        components: {
            Sidebar,
            BackTop
        },
        data: function () {
            const email = this.$store.state.user ? this.$store.state.user : ''
            let isAdmin = false
            // if (email && email.indexOf(config.defaultAdminMailDomain) > -1) {
            //     isAdmin = true
            // }
            if (this.$route.path.match(/^\/developerAdmin/i)) {
                isAdmin = true
            }
            let protocol = window.location.protocol
            let env = window.location.hostname.split('.')[0]
            let forumPort = env === 'localhost' ? '4567' : '80'
            let port = env === 'localhost' ? '8060' : '80'
            if (protocol === 'https:') {
                forumPort = '443'
                port = '443'
            }
            env = window.location.hostname
            return {
                // section: 'Dash',
                year: new Date().getFullYear(),
                lang: '',
                email: email,
                isAdmin,
                classes: {
                    fixed_layout: config.fixedLayout,
                    hide_logo: config.hideLogoOnMobile
                },
                error: '',
                forumUrl: protocol + '//' + env + ':' + forumPort + '/forum/',
                gitbookUrl: protocol + '//' + env + ':' + port + '/gitbook/'
            }
        },
        computed: {
            ...mapState([
                'userInfo'
            ]),
            demo () {
                return {
                    displayName: faker.name.findName(),
                    avatar: faker.image.avatar(),
                    email: faker.internet.email(),
                    randomCard: faker.helpers.createCard()
                }
            }
        },
        methods: {
            changeloading () {
                this.$store.commit('TOGGLE_SEARCHING')
            },
            $_admin_dash_back () {
                this.$router.go(-1)
            },
            // 切换语言
            $_admin_dash_change_lang (lang) {
                if (lang) {
                    this.$root.$i18n.locale = lang
                    this.lang = lang
                } else {
                    this.$root.$i18n.locale = this.lang
                }
            },
            $_admin_index_login () {
                this.$router.push({name: 'userLogin'})
            },
            $_admin_index_register () {
                this.$router.push({name: 'userRegister'})
            }
        }
    }
</script>

<style lang="scss">
    // .btnBackTop{
    //     position: absolute;
    //     bottom: 2.7%!important;
    //     right: 3.5%!important;
    //     transition: 0.7s;
    // }
    // [fu]
    .wrapper{
        margin-top:-3px; 
        height: 1490px;
        height: fit-content;
    }
    // .skin-blue .wrapper{
    //     height: fit-content;
    // }
    .content-wrapper{
        height: 100%;
    }
    .sidebar-form, .sidebar-menu>li.header{
        display: none;
    }
    .skin-blue .wrapper, .skin-blue .main-sidebar, .skin-blue .left-side{
        background: #e5fbfb;
    }
    .main-sidebar{
        padding-top: 114px!important;
    }
    .sidebar-menu>li>a[data-v-5e01fd2d]{
        padding: 16px 24px 14px 24px!important;
    }
    .sidebar-menu>li>a>.fa{
        display: none;
    }
    .sidebar-menu>li{
        margin-left: 34px;
    }
    .skin-blue .sidebar-menu>li:hover>a, .skin-blue .sidebar-menu>li.active>a{
        background: #cdf7f7;
    }
    .sidebar-menu>li span{
        width: 212px;
        height: 34px;
        font-family: sans-serif;
        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        color: #00b5e2;
    }
    .sidebar-menu li>a>.pull-right{
        display: none;
    }
    .content-wrapper, .right-side, .main-footer{
        margin-left: 296px;
   
    }
    .main-sidebar{
        width: none!important;
    }
    .skin-blue .sidebar-menu>li>a{
        border-left:none;
        border-bottom: solid 3px #9ff2f0;
    }
    .skin-blue .sidebar-menu>li>a:hover{
        border-left:none;
        border-bottom: solid 3px #9ff2f0;
        // border-width: 200px;
    }
  .sidebar-menu .treeview-menu>li>a>.fa, .sidebar-menu .treeview-menu>li>a>.glyphicon, .sidebar-menu .treeview-menu>li>a>.ion{
      display: none;
  }

   .main-sidebar{
        width: 296px;
    }

  .skin-blue .sidebar-menu>li>.treeview-menu{
      background: none;
  }
  .sidebar-menu .treeview-menu{
      padding-left: 0px!important;
  }

  .sidebar-menu .treeview-menu>li{
      padding-top: 4px;
      padding-bottom: 7px;
  }
    .treeview-menu .menu-open>li>span{
      font-family: sans-serif;
      font-size: 20px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1.1px;
      color: rgba(51, 51, 51, 0.8)!important;
  }
    .content-wrapper, .right-side, .main-footer{
      background: #fff;
    }
    .center-block {
        padding-bottom: 3.5em;
        margin-top: 133px;
    }
    .sidebar-menu {
        list-style: none;
        margin: 0;
        padding: 0;
        margin-top: 153px;
    }
    .box{
        border-top: none;
    }
    .content-wrapper, .right-side, .main-footer{
        padding-left: 112px;
    }
    ul.navbar-nav{
        padding-right: 0!important;
    }
    .main-sidebar{
        padding-top: 80px!important;
    }
    .text-center{
        margin-top: 0;
    }
    .center-block {
        padding-bottom: 3.5em;
        margin-top: 133px;
        padding-bottom: 480px;
    }
    // .center-blockA {
    //     padding-bottom: 480px;
    // }
    .sidebar-menu > li > a[data-v-5e01fd2d] {
        padding: 18px 24px 16px 24px !important;
    }
    .sidebar-menu .treeview-menu>li>a {
        padding: 8px 5px 2px 15px;
        display: block;
        font-size: 14px;
    }
    .sidebar-menu .treeview-menu > li span{
            opacity: 0.8;
            font-family: sans-serif;
            font-size: 20px;
            font-weight: 300;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 1.1px;
            color: rgba(51, 51, 51, 0.8);
        }
    .sidebar-menu .treeview-menu > li:hover{
            background: #cdf7f7;
        }
        .sidebar-menu>li>a[data-v-5e01fd2d]:hover{
        background: #cdf7f7;
    }
    .skin-blue .treeview-menu>li>a{

        border-left: 4px solid #9ff2f0;
    }
 
    // [fu]
    .wrapper.fixed_layout {
    .main-header {
        position: fixed;
        width: 100%;
    }

    .content-wrapper {
        padding-top: 50px;

    }

    .main-sidebar {
        position: fixed;
        height: 100vh;
    }
    }

    .wrapper.hide_logo {
    @media (max-width: 767px) {
        .main-header .logo {
            display: none;
        }
    }
    }

    .logo-mini,
    .logo-lg {
        text-align: left;

    img {
        padding: .4em !important;
    }
    }

    .logo-lg {
    img {
        display: -webkit-inline-box;
        width: 25%;
    }
    }

    .user-panel {
        height: 4em;
    }

    hr.visible-xs-block {
        width: 100%;
        background-color: rgba(0, 0, 0, 0.17);
        height: 1px;
        border-color: transparent;
    }
    
    .marginTopMinus50px {
        margin-top: -50px;
    }
    .marginTopMinus70px {
        margin-top: -70px;
    }
    .main-sidebar>.navbar2 {
        margin-left: 0px;
    }
    .main-sidebar {
        padding-top: 100px;
    }
    ul.navbar-nav {
        padding-right: 10px;
    }
    ul.indexSteps .indexStepLi {
        width: 15%;
        line-height: 68px;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        transition: background-color .3s;
        display: inline-block;
        background: #3c8dbc;
        border-right: 0px solid rgba(0,0,0,.06);
    }
    ul.indexSteps .indexStepLi.current:first-child, ul.indexSteps .indexStepLi.finish:first-child {
        border-left: none;
    }
    ul.indexSteps .indexStepLi.current {
        background: #48e7cf;
    }
    ul.indexSteps .indexStepLi.current, ul.indexSteps .indexStepLi.finish {
        border-left: 1px solid hsla(0,0%,100%,.2);
        border-right: none;
    }
    .indexSteps .indexStepLi span {
        width: 24px;
        height: 24px;
        line-height: 22px;
        color: #fff;
        font-size: 14px;
        border-radius: 50%;
        border: 1px solid #fff;
        text-align: center;
        display: inline-block;
        margin-right: 10px;
    }
    ul.resourceSteps .resourceStepLi {
        line-height: 34px;
        color: black;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        transition: background-color .3s;
        background: #fff;
        border-right: 0px solid rgba(0,0,0,.06);
    }
    .w100 {
        width: 100%;
    }

   
</style>



// WEBPACK FOOTER //
// Dash.vue?58109e58